import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import ThirdStepKindergarten from "src/components/panel/applications_kindergarten/application_third_step/ThirdStep";
import * as AppConfig from "../../../../helpers/AppConfig";

const MakeApplicationsThirdStepKindergartenView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("applications_list_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb title={t("applications_title")} />
        <ThirdStepKindergarten />
      </Sidebar>
    </>
  );
};

export default MakeApplicationsThirdStepKindergartenView;
